import { ISignature } from 'Modules/Communication/shared/models/Signature'

export interface SystemState {
  emailSettings: {
    signature: {
      data: ISignature | null
      loading: string
      error: any
      processing: boolean
      processingError: any
    }
  }
}

export const getEmailSignature = (state: SystemState) =>
  state.emailSettings.signature
